export default __webpack_public_path__ + "static/office2-2x-8644c552d0658e1e9a57126a339b9060.jpg";